@use 'sass:math';
@import 'apps/webcomponents/src/assets/widget-shared.scss';
@import 'apps/webcomponents/src/assets/flexbox-helpers.scss';
@import 'apps/webcomponents/src/assets/common.scss';

:host {
  background-color: var(--white-layout-301-level-0-elevation);
  max-width: 100%;
  padding: 0 0 calc(var(--spacer) * 3) var(--spacer);
}

:host(.widget-is-loading) {
  #timeRangeSelector {
    pointer-events: none;
    opacity: 0.5;
  }
}

.page__header {
  padding: calc(2 * var(--spacer));
}

.wrapper {
  flex-direction: column;
  justify-content: space-between;

  .dashboard-loader {
    display: none;
    padding: 0 var(--spacer);
  }

  &.is-loading {
    .widgets {
      display: none;
    }

    .dashboard-loader {
      display: block;
    }
  }
}

.grid {
  position: relative;
  width: 100%;
  height: 100vh !important;
}

.title {
  color: var(--main-titles-inputs-600);
}

.dashboard-header {
  display: flex;
  justify-content: end;
  margin-bottom: calc(var(--spacer) * 3);
  padding-left: var(--spacer);
  padding-right: var(--spacer);

  &--items {
    display: flex;
  }

  &--item {
    flex: 1;

    &:not(:first-child) {
      margin-left: 10px;
    }
  }
}

#dashboardActions {
  .ds-icon-textbox_decrease {
    font-size: 25px;
    line-height: 0;
    vertical-align: middle;
    display: inline-block;
    width: 15px;
  }
}

.reporting-period-wrapper {
  font-size: var(--body-size-medium);
  text-align: right;
  padding: 0 var(--spacer);
  margin-bottom: var(--spacer);
}

.dashboard-refresh-button {
  width: calc(3 * var(--spacer));
  height: calc(3 * var(--spacer));
  margin-right: calc(-1 * var(--spacer));
}

/*-- GridStack START --*/
.grid-stack-item-content {
  color: var(--body-text-arrows-400);
}

$gridstack-columns: 12 !default;
$horizontal_padding: var(--spacer) !default;
$vertical_padding: var(--spacer) !default;
$animation_speed: 0.3s !default;

@mixin vendor($property, $value...) {
  -webkit-#{$property}: $value;
  -moz-#{$property}: $value;
  -ms-#{$property}: $value;
  -o-#{$property}: $value;
  #{$property}: $value;
}

:root .grid-stack-item > .ui-resizable-handle {
  filter: none;
}

.grid-stack {
  position: relative;

  &.grid-stack-rtl {
    direction: ltr;

    > .grid-stack-item {
      direction: rtl;
    }
  }

  .grid-stack-placeholder > .placeholder-content {
    border: 1px dashed lightgray;
    margin: 0;
    position: absolute;
    top: 0;
    left: $horizontal_padding;
    right: $horizontal_padding;
    bottom: 0;
    width: auto;
    z-index: 0 !important;
    text-align: center;
  }

  > .grid-stack-item {
    min-width: math.div(100%, $gridstack-columns);
    position: absolute;
    padding: 0;

    > .grid-stack-item-content {
      margin: 0;
      width: auto;
      position: absolute;
      top: 0;
      left: $horizontal_padding;
      right: $horizontal_padding;
      bottom: calc(var(--spacer) * 2);
      overflow-x: hidden;
      overflow-y: auto;
      border: 1px solid var(--chart-101-pressed-dividers);
      border-radius: var(--widget-border-radius);
      padding: calc(1.5 * var(--spacer)) calc(3 * var(--spacer));
      background-color: var(--white-layout-302-level-1-elevation);
      display: flex;
      justify-content: center;
      align-items: center;
    }

    > .ui-resizable-handle {
      position: absolute;
      font-size: 0.1px;
      display: block;
      -ms-touch-action: none;
      touch-action: none;
    }

    &.ui-resizable-disabled > .ui-resizable-handle,
    &.ui-resizable-autohide > .ui-resizable-handle {
      display: none;
    }

    &.ui-draggable-dragging,
    &.ui-resizable-resizing {
      z-index: 100;

      > .grid-stack-item-content,
      > .grid-stack-item-content {
        box-shadow: 1px 4px 6px var(--chart-050-hover);
        opacity: 0.8;
      }
    }

    > .ui-resizable-se,
    > .ui-resizable-sw {
      background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCIgdmlld0JveD0iMCAwIDUxMS42MjYgNTExLjYyNyIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTExLjYyNiA1MTEuNjI3OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnPgoJPHBhdGggZD0iTTMyOC45MDYsNDAxLjk5NGgtMzYuNTUzVjEwOS42MzZoMzYuNTUzYzQuOTQ4LDAsOS4yMzYtMS44MDksMTIuODQ3LTUuNDI2YzMuNjEzLTMuNjE1LDUuNDIxLTcuODk4LDUuNDIxLTEyLjg0NSAgIGMwLTQuOTQ5LTEuODAxLTkuMjMxLTUuNDI4LTEyLjg1MWwtNzMuMDg3LTczLjA5QzI2NS4wNDQsMS44MDksMjYwLjc2LDAsMjU1LjgxMywwYy00Ljk0OCwwLTkuMjI5LDEuODA5LTEyLjg0Nyw1LjQyNCAgIGwtNzMuMDg4LDczLjA5Yy0zLjYxOCwzLjYxOS01LjQyNCw3LjkwMi01LjQyNCwxMi44NTFjMCw0Ljk0NiwxLjgwNyw5LjIyOSw1LjQyNCwxMi44NDVjMy42MTksMy42MTcsNy45MDEsNS40MjYsMTIuODUsNS40MjYgICBoMzYuNTQ1djI5Mi4zNThoLTM2LjU0MmMtNC45NTIsMC05LjIzNSwxLjgwOC0xMi44NSw1LjQyMWMtMy42MTcsMy42MjEtNS40MjQsNy45MDUtNS40MjQsMTIuODU0ICAgYzAsNC45NDUsMS44MDcsOS4yMjcsNS40MjQsMTIuODQ3bDczLjA4OSw3My4wODhjMy42MTcsMy42MTcsNy44OTgsNS40MjQsMTIuODQ3LDUuNDI0YzQuOTUsMCw5LjIzNC0xLjgwNywxMi44NDktNS40MjQgICBsNzMuMDg3LTczLjA4OGMzLjYxMy0zLjYyLDUuNDIxLTcuOTAxLDUuNDIxLTEyLjg0N2MwLTQuOTQ4LTEuODA4LTkuMjMyLTUuNDIxLTEyLjg1NCAgIEMzMzguMTQyLDQwMy44MDIsMzMzLjg1Nyw0MDEuOTk0LDMyOC45MDYsNDAxLjk5NHoiIGZpbGw9IiM2NjY2NjYiLz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8L3N2Zz4K);
      background-repeat: no-repeat;
      background-position: center;
      @include vendor(transform, rotate(45deg));
    }

    > .ui-resizable-se {
      @include vendor(transform, rotate(-45deg));
    }

    > .ui-resizable-nw {
      cursor: nw-resize;
      width: 20px;
      height: 20px;
      left: 10px;
      top: 0;
    }

    > .ui-resizable-n {
      cursor: n-resize;
      height: 10px;
      top: 0;
      left: 25px;
      right: 25px;
    }

    > .ui-resizable-ne {
      cursor: ne-resize;
      width: 20px;
      height: 20px;
      right: 10px;
      top: 0;
    }

    > .ui-resizable-e {
      cursor: e-resize;
      width: 10px;
      right: $horizontal_padding / 2;
      top: 15px;
      bottom: 15px;
    }

    > .ui-resizable-se {
      cursor: se-resize;
      width: 20px;
      height: 20px;
      right: 10px;
      bottom: $horizontal_padding;
    }

    > .ui-resizable-s {
      cursor: s-resize;
      height: 10px;
      left: 25px;
      bottom: 0;
      right: 25px;
    }

    > .ui-resizable-sw {
      cursor: sw-resize;
      width: 20px;
      height: 20px;
      left: 10px;
      bottom: 0;
    }

    > .ui-resizable-w {
      cursor: w-resize;
      width: 10px;
      left: $horizontal_padding / 2;
      top: 15px;
      bottom: 15px;
    }

    &.ui-draggable-dragging {
      & > .ui-resizable-handle {
        display: none !important;
      }
    }

    @for $i from 1 through $gridstack-columns {
      &[gs-w='#{$i}'] {
        width: math.div(100%, $gridstack-columns) * $i;
      }
      &[gs-x='#{$i}'] {
        left: math.div(100%, $gridstack-columns) * $i;
      }
      &[gs-min-w='#{$i}'] {
        min-width: math.div(100%, $gridstack-columns) * $i;
      }
      &[gs-max-w='#{$i}'] {
        max-width: math.div(100%, $gridstack-columns) * $i;
      }
    }
  }

  &.grid-stack-1 > .grid-stack-item {
    min-width: 100%;

    &[gs-w='1'] {
      width: 100%;
    }

    &[gs-x='1'] {
      left: 100%;
    }

    &[gs-min-w='1'] {
      min-width: 100%;
    }

    &[gs-max-w='1'] {
      max-width: 100%;
    }
  }

  &.grid-stack-animate,
  &.grid-stack-animate .grid-stack-item {
    @include vendor(
      transition,
      left $animation_speed,
      top $animation_speed,
      height $animation_speed,
      width $animation_speed
    );
  }

  &.grid-stack-animate .grid-stack-item.ui-draggable-dragging,
  &.grid-stack-animate .grid-stack-item.ui-resizable-resizing,
  &.grid-stack-animate .grid-stack-item.grid-stack-placeholder {
    @include vendor(transition, left 0s, top 0s, height 0s, width 0s);
  }
}

/*-- GridStack END --*/

/*-- Template pdf START --*/

:host([data-display-mode='pdf']) {
  width: 26cm;
  min-height: 29.7cm;
  padding: 1cm;

  .dashboard-header {
    justify-content: flex-start;
    margin-bottom: calc(var(--spacer) * 4);
    align-items: center;
  }

  .page__header {
    display: none;
  }

  .pdf-title {
    display: block !important;
  }

  #companySelectorDropdown,
  #timeRangeDropdown,
  #dashboard-refresh {
    display: none;
  }
  .company-title-container {
    flex-grow: 1;

    &.line-separator {
      padding-left: calc(var(--spacer) + 2px);
      display: flex;
      flex-direction: row;

      &:before {
        content: '';
        width: 2px;
        height: auto;
        margin-right: 10px;
        background-color: var(--title-separator-color);
      }
    }
  }
  .company-title {
    max-width: 430px;
    display: block !important;
    word-wrap: break-word;
  }

  .company-logo {
    display: block;

    img {
      filter: invert(1);
    }
  }

  .reporting-period-wrapper {
    text-align: left;

    .reporting-period-interval,
    .reporting-period-title {
      color: var(--chart-300-icon-buttons);
    }
    .reporting-period-interval {
      padding-left: 5px;
    }
  }

  .widgets {
    .item.item-type-3,
    .item.item-type-4 {
      margin-top: 230px;
    }
    .item.item-type-7,
    .item.item-type-8 {
      margin-top: 390px;
    }
    .item.item-type-5 {
      .grid-stack-item-content {
        line-height: 20px;
      }
    }

    .item {
      &.item-type-1,
      &.item-type-2 {
        height: 420px !important;
        max-height: 420px !important;
      }

      &.item-type-3,
      &.item-type-4,
      &.item-type-7,
      &.item-type-8 {
        height: 336px;
        max-height: 336px;
      }

      &.item-type-6,
      &.item-type-9,
      &.item-type-10 {
        margin-top: 270px;
      }
      &.item-type-11 {
        margin-top: 430px;
      }
    }
  }

  .company-logo.is-custom {
    width: 200px;
    height: 25px;
    filter: invert(1);
  }

  .company-logo.is-default {
    width: 200px;
    height: 25px;
    filter: invert(1);
    background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 383.71 55.16'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:none;%7D.cls-2%7Bclip-path:url(%23clip-path);%7D.cls-3%7Bfill:%23ffffff;%7D%3C/style%3E%3CclipPath id='clip-path' transform='translate(-99.66 -74.13)'%3E%3Crect class='cls-1' width='582.43' height='215.55'/%3E%3C/clipPath%3E%3C/defs%3E%3Ctitle%3EBitdefender-Logo-BW-%3C/title%3E%3Cg id='Layer_2' data-name='Layer 2'%3E%3Cg id='Layer_1-2' data-name='Layer 1'%3E%3Cg class='cls-2'%3E%3Cpath class='cls-3' d='M252,93.05c-10.42,0-18,7.26-18,18.12s8,18.12,19.52,18.12a24.12,24.12,0,0,0,9.22-1.71l4.91-8.2L267,119a27.94,27.94,0,0,1-12.7,3.35c-5.95,0-11.1-3-11.67-8.19h26.31v-2.38c0-12-7.29-18.76-16.92-18.76m-9.39,14.67c.64-5,3.81-8.2,8.91-8.2,5.4,0,8.71,3.17,8.77,8.2ZM431.28,93.05c-10.44,0-18,7.26-18,18.12s8,18.12,19.52,18.12a24,24,0,0,0,9.2-1.71l4.93-8.2-.65-.35a28,28,0,0,1-12.71,3.35c-5.94,0-11.08-3-11.66-8.19H448.2c1.14-13.52-6.13-21.14-16.92-21.14m-9.39,14.67c.63-5,3.81-8.2,8.9-8.2,5.4,0,8.71,3.17,8.78,8.2ZM310.7,93.05c-10.42,0-18,7.26-18,18.12s8,18.12,19.52,18.12a24.08,24.08,0,0,0,9.22-1.71l4.91-8.2-.66-.35A27.87,27.87,0,0,1,313,122.38c-5.95,0-11.09-3-11.67-8.19h26.32c1.14-13.52-6.14-21.14-16.94-21.14m-9.38,14.67c.64-5,3.81-8.2,8.91-8.2,5.39,0,8.71,3.17,8.77,8.2Zm-168.9-6.12v-.14c5.25-1.58,8.84-5.39,8.84-11.14,0-9.28-7.91-12.8-15.59-12.8h-26v.76l2.61,2.22c3.14,2.56,3.54,3.05,3.54,5.36v42.58h18.35c9.62,0,19.27-3.45,19.27-14.53a12.13,12.13,0,0,0-11-12.3M114.88,85.28h7.47c5.06,0,6.62.7,8.15,2.16a5.79,5.79,0,0,1,1.7,4.39,5.7,5.7,0,0,1-1.75,4.25c-1.5,1.44-3.56,2.14-7.31,2.14h-8.26Zm8.34,35.38h-8.34V106h8.7c7.33,0,10.78,1.87,10.78,7.19,0,6.69-6.48,7.48-11.14,7.48m37.33-38.47A5.55,5.55,0,1,1,155,77a5.31,5.31,0,0,1,5.6,5.18M146.06,93.92h13.27v34.51h-8.64V101.27h0c0-2.85-.16-3.31-3.26-5.7l-1.37-1.09ZM214.74,76l2.71,1.74c2.46,1.57,2.83,2.32,2.83,4.51v16h-.21c-1.8-2.23-5.25-5.25-11.72-5.25-9.85,0-16.69,7.91-16.69,18.12s6.41,18.12,17.05,18.12c4.81,0,9.35-1.87,11.87-6h.14l.9,5.18h7.29V75.38H214.74Zm-4.31,45.5c-6.32,0-10.14-5-10.14-10.35s3.82-10.35,10.14-10.35,10.15,5,10.15,10.35-3.82,10.35-10.15,10.35M393.72,76l1.2.8c4.16,2.63,4.68,3.39,4.68,7.88V98.3h-.22c-1.81-2.23-5.25-5.25-11.72-5.25-9.85,0-16.68,7.91-16.68,18.12s6.4,18.12,17,18.12c4.82,0,9.36-1.87,11.87-6H400l.91,5.18h7.29V75.38h-14.5Zm-4,45.5c-6.32,0-10.14-5-10.14-10.35s3.82-10.35,10.14-10.35,10.14,5,10.14,10.35-3.81,10.35-10.14,10.35m86.12-28v8.34a17.27,17.27,0,0,0-4.17-.65c-8.12,0-9.28,6.84-9.28,8.71v18.48h-8.62V102.92c0-4.34-.23-5-3.74-7.21l-2.17-1.43,0-.38h14.55v5.48h.15a11,11,0,0,1,10.21-6.33,11.35,11.35,0,0,1,3.09.5m-191.6.22h8v7.36h-8v27.3H275.6V104.11c0-2.89-.58-3.53-4-6.24l-4.4-3.58v-.52h8.41V87.48c0-9.37,6.11-15.32,19.33-12.68l2,7.31-.42.34c-6.91-2.72-12.26-1-12.26,5ZM366,106.63v21.8h-8.63V109.22c0-3.8-1-8.4-7-8.4-5.68,0-7.91,4.17-7.91,8.77v18.84h-8.62V102.92c0-4.34-.23-5-3.74-7.21L328,94.28V93.9h6.75v0h7.35v5.25h.14a13.37,13.37,0,0,1,11-6.12c8.15,0,12.85,5.58,12.85,13.58M189,121.49l.28.18s-4.29,6.86-4.28,6.86c-7,1.91-14.94-.12-14.94-11.4v-14c0-2.23-.36-2.11-5.2-6.1l-3.13-2.71v-.41h8.38l3.15-10h5.47v10h9.23v7.32h-9.23v15.65c0,6.23,4.27,6.38,10.28,4.6' transform='translate(-99.66 -74.13)'/%3E%3Cpath class='cls-3' d='M477.89,76.68h-2.12V83.2H476v-3h1.89l.12,0h0l0,0,2,3h.29l-2-3.09h.08A2.7,2.7,0,0,0,479,80a1.84,1.84,0,0,0,.54-.32,1.35,1.35,0,0,0,.36-.51,1.7,1.7,0,0,0,.14-.71,1.63,1.63,0,0,0-.52-1.28,2.39,2.39,0,0,0-1.63-.46m1.92,1.74a1.3,1.3,0,0,1-.75,1.26,2.34,2.34,0,0,1-.7.19,5.94,5.94,0,0,1-.72,0H476v-3h1.87a3.35,3.35,0,0,1,.71.07,1.75,1.75,0,0,1,.63.23,1.12,1.12,0,0,1,.43.46,1.53,1.53,0,0,1,.17.76' transform='translate(-99.66 -74.13)'/%3E%3Cpath class='cls-3' d='M482.92,82.06a5.73,5.73,0,0,0-3-7.48,5.47,5.47,0,0,0-2.22-.45,5.55,5.55,0,0,0-2.23.45,5.67,5.67,0,0,0-1.8,1.22,5.61,5.61,0,0,0-1.22,1.81,5.73,5.73,0,0,0,0,4.45,5.66,5.66,0,0,0,1.22,1.81,5.49,5.49,0,0,0,1.8,1.21,5.55,5.55,0,0,0,2.23.44,5.63,5.63,0,0,0,4-1.65,5.69,5.69,0,0,0,1.23-1.81m-3.12,2.83a5.64,5.64,0,0,1-4.27,0,5.42,5.42,0,0,1-3.33-5.06A5.41,5.41,0,0,1,473.79,76a5.58,5.58,0,0,1,1.74-1.18,5.52,5.52,0,0,1,4.27,0A5.65,5.65,0,0,1,481.53,76a5.5,5.5,0,0,1,1.17,1.74,5.26,5.26,0,0,1,.44,2.12A5.33,5.33,0,0,1,482.7,82a5.73,5.73,0,0,1-1.17,1.74,5.87,5.87,0,0,1-1.73,1.17' transform='translate(-99.66 -74.13)'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E")
      no-repeat right;
    img {
      display: none;
    }
  }
}

/*-- Template pdf END --*/

/*-- Template report START --*/

:host([data-display-mode='report']) {
  #companySelectorDropdown,
  #timeRangeDropdown,
  #dashboard-refresh,
  .company-title,
  .company-logo,
  .reporting-period-wrapper {
    display: none;
  }

  .widgets {
    min-height: 1670px !important;

    .item-type-1,
    .item-type-2 {
      height: 420px;
      max-height: 420px;
    }
    .item-type-3,
    .item-type-4 {
      top: 630px;
      height: 420px;
      max-height: 420px;
    }
    .item-type-7,
    .item-type-8 {
      top: 1050px;
      height: 336px;
      max-height: 336px;
    }
    .item-type-6,
    .item-type-9,
    .item-type-10 {
      top: 1386px;
    }
  }
}
